<template>
    <div class="consultar_matriz">
        <ConsultarMatriz :id="id" />
    </div>
</template>

<script>
import ConsultarMatriz from '../../components/MatrizPeligros/ConsultarMatriz.vue';
export default {
    name: 'consultar_matriz',

    components: {
        ConsultarMatriz
    },

    data() {
        return {
            id: this.$route.params.id
        }
    },

    watch: {
        $route(to) {
            this.id = to.params.id;
        },
    },

    created() {
        if (!this.$store.state.global_privilegio_matriz_peligro.consultar) {
            this.$router.replace("/lista_clientes");
        } else {
            if (!this.$store.state.email) {
                this.$router.replace("/");
                return;
            }
        }
    }
}
</script>